export default __webpack_public_path__ + "static/media/circleCloud2.913d3229.webp";